"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Button_1 = __importDefault(require("../../../../../../../components/Button"));
var schemaHelper_1 = require("../../../../../../../helpers/schemaHelper");
var react_redux_1 = require("react-redux");
var postSlice_1 = require("../../../../../../../features/post/postSlice");
var FormHeader_1 = __importDefault(require("./FormHeader"));
var FormSkeleton_1 = __importDefault(require("./FormSkeleton"));
var FormAction_1 = __importDefault(require("./FormAction"));
var EntityRow_1 = __importDefault(require("./EntityRow/EntityRow"));
var validateEntityRequiredFields_1 = require("../../../../../../../helpers/validateEntityRequiredFields");
var PostTabsContext_1 = require("../../../../../../../contexts/PostTabsContext");
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var ApartmentForm = function (_a) {
    var _b;
    var index = _a.index, step = _a.step, formikProps = _a.formikProps, apartmentId = _a.apartmentId, uploadMedia = _a.uploadMedia, uploadEntityPlanMedia = _a.uploadEntityPlanMedia, removeEntityPlanMedia = _a.removeEntityPlanMedia, removeEntityMedia = _a.removeEntityMedia, reorderMedia = _a.reorderMedia, duplicateApartment = _a.duplicateApartment, removeApartment = _a.removeApartment, canRemove = _a.canRemove, handleSubmitApartmentForm = _a.handleSubmitApartmentForm, isApartmentFormSubmitted = _a.isApartmentFormSubmitted, setCollapsedApartmentId = _a.setCollapsedApartmentId, collapsedApartmentId = _a.collapsedApartmentId, hasApartmentsErrors = _a.hasApartmentsErrors;
    var setIsFormErrors = react_1.useContext(PostTabsContext_1.PostTabsContext).setIsFormErrors;
    var dispatch = react_redux_1.useDispatch();
    var t = react_i18next_1.useTranslation('common').t;
    var _c = react_1.useState(false), isCollapsed = _c[0], setIsCollapsed = _c[1];
    var _d = react_1.useState(false), apartmentLoading = _d[0], setApartmentLoading = _d[1];
    var rows = step.fields.rows, order = step.order, name = step.name;
    var primaryRows = react_1.useMemo(function () {
        return rows.filter(function (r) { return !r.config.collapsed; });
    }, [rows]);
    var collapsibleRows = react_1.useMemo(function () {
        return rows.filter(function (r) { return r.config.collapsed; });
    }, [rows]);
    var validatedPrimaryRows = react_1.useMemo(function () {
        if (apartmentId === collapsedApartmentId) {
            return schemaHelper_1.excludeFieldsByCondition(primaryRows, formikProps.values);
        }
    }, [
        apartmentId,
        collapsedApartmentId,
        formikProps.values.initial_info.property_type,
        formikProps.values.deal,
    ]);
    var validatedCollapsibleRows = react_1.useMemo(function () {
        if (apartmentId === collapsedApartmentId) {
            return schemaHelper_1.excludeFieldsByCondition(collapsibleRows, formikProps.values);
        }
    }, [apartmentId, collapsedApartmentId]);
    react_1.useEffect(function () {
        return function () {
            dispatch(postSlice_1.clearPostFailureErrors());
        };
    }, []);
    var handleDuplicateEntity = function (entityId) {
        var hasErrors = validateEntityRequiredFields_1.validateEntityRequiredFields(formikProps);
        !hasErrors ? duplicateApartment(entityId) : setIsFormErrors(true);
    };
    var handleOpenApartmentCard = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var hasErrors, entity, findIndex;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    hasErrors = false;
                    if (collapsedApartmentId) {
                        hasErrors = validateEntityRequiredFields_1.validateEntityRequiredFields(formikProps);
                    }
                    if (!!hasErrors) return [3 /*break*/, 2];
                    setCollapsedApartmentId(id);
                    dispatch(postSlice_1.clearPostFailureErrors());
                    setApartmentLoading(true);
                    setIsCollapsed(true);
                    return [4 /*yield*/, dispatch(postSlice_1.getPostEntity(id))];
                case 1:
                    entity = _a.sent();
                    findIndex = formikProps.values.apartment_info.findIndex(function (item) { return item.id === id; });
                    formikProps.setFieldValue("apartment_info[" + findIndex + "]", entity);
                    setApartmentLoading(false);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement("div", { className: classnames_1.default('title', (_b = {
                    active: collapsedApartmentId === apartmentId
                },
                _b[styles_module_scss_1.default.errorRow] = hasApartmentsErrors &&
                    collapsedApartmentId !== apartmentId,
                _b)), onClick: function () {
                return apartmentId !== collapsedApartmentId &&
                    handleOpenApartmentCard(apartmentId);
            } },
            react_1.default.createElement(FormHeader_1.default, { entityId: apartmentId, index: index, duplicateApartment: handleDuplicateEntity, removeApartment: removeApartment, canRemove: canRemove })),
        !!(validatedPrimaryRows === null || validatedPrimaryRows === void 0 ? void 0 : validatedPrimaryRows.length) && (react_1.default.createElement("div", { className: classnames_1.default('content', styles_module_scss_1.default.apartment_form_content, {
                active: collapsedApartmentId === apartmentId,
            }) },
            react_1.default.createElement("div", { className: classnames_1.default('ui grid stackable form', styles_module_scss_1.default.nested_section) },
                apartmentLoading ? (react_1.default.createElement(FormSkeleton_1.default, null)) : (react_1.default.createElement(EntityRow_1.default, { isMoreSection: false, formikProps: formikProps, index: index, name: name, order: order, validatedPrimaryRows: validatedPrimaryRows, entityId: apartmentId, removeEntityMedia: removeEntityMedia, removeEntityPlanMedia: removeEntityPlanMedia, reorderMedia: reorderMedia, uploadMedia: uploadMedia, uploadEntityPlanMedia: uploadEntityPlanMedia })),
                !apartmentLoading && (react_1.default.createElement("div", { className: classnames_1.default('row', styles_module_scss_1.default.more_details) },
                    isCollapsed && (react_1.default.createElement(Button_1.default, { variant: "outline", onClick: function (e) {
                            e.preventDefault();
                            setIsCollapsed(!isCollapsed);
                        } }, t('POST_SCREEN.MORE_DETAILS'))),
                    react_1.default.createElement(FormAction_1.default, { formikProps: formikProps, entityId: apartmentId, collapsedApartmentId: collapsedApartmentId, handleSubmitApartmentForm: handleSubmitApartmentForm, isApartmentFormSubmitted: isApartmentFormSubmitted }))),
                !isCollapsed && (react_1.default.createElement("div", { className: "row" },
                    react_1.default.createElement("div", { className: "column" },
                        react_1.default.createElement("div", { className: classnames_1.default('ui grid stackable', styles_module_scss_1.default.more_details_collapsible) },
                            react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.more_details_collapsible_header) },
                                react_1.default.createElement("h4", null, t('POST_SCREEN.MORE_DETAILS')),
                                react_1.default.createElement(Button_1.default, { variant: "outline", onClick: function (e) {
                                        e.preventDefault();
                                        setIsCollapsed(!isCollapsed);
                                    } }, t('POST_SCREEN.CLOSE'))),
                            react_1.default.createElement(EntityRow_1.default, { isMoreSection: true, formikProps: formikProps, index: index, name: name, order: order, validatedPrimaryRows: validatedCollapsibleRows, entityId: apartmentId, removeEntityMedia: removeEntityMedia, removeEntityPlanMedia: removeEntityPlanMedia, reorderMedia: reorderMedia, uploadMedia: uploadMedia, uploadEntityPlanMedia: uploadEntityPlanMedia }))))))))));
};
exports.default = ApartmentForm;
